// Configuration for Webinar Wizard

// Phase 2: Make.com Webhook Integration
// Calls serverless proxy at /api/submit which forwards to Make.com
export const WEBHOOK_URL = '/api/submit';

// Feature flags for phased rollout
export const FEATURES = {
  // Phase 1: Core questionnaire (always enabled)
  questionnaire: true,

  // Phase 2: Webhook submission to Make.com
  webhookSubmission: true,

  // Phase 3: Results display and PDF download
  resultsDisplay: true,
  pdfDownload: true,
};

// Supabase configuration (Phase B1 — primary data store)
export const SUPABASE_CONFIG = {
  url: import.meta.env.VITE_SUPABASE_URL,
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  table: 'webinars',
};

// Polling configuration
export const POLLING_CONFIG = {
  intervalMs: 15000,      // Poll every 15 seconds
  timeoutMs: 360000,      // Give up after 6 minutes
  estimatedTimeMs: 300000, // Show ~5 min estimate to user
};

// Local storage keys
export const STORAGE_KEYS = {
  formData: 'webinar-wizard-form-data',
  currentStep: 'webinar-wizard-current-step',
  webinarResults: 'webinarResults',
  currentJobId: 'currentJobId',
} as const;

// Animation durations (in seconds)
export const ANIMATIONS = {
  pageTransition: 0.3,
  stagger: 0.1,
  spring: {
    type: 'spring' as const,
    stiffness: 300,
    damping: 30,
  },
};

// Form validation
export const VALIDATION = {
  minAnswerLength: 10,
  maxAnswerLength: 2000,
};
